import React from 'react';
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";


export default function ArgoTemplateListCreateFabHook(props) {

    const fileName = props.fileName ?? "file-name";
    const fieldName = props.fieldName ?? "field-name";

    const uniqueIdentifier = fileName + "-fab-" + fieldName;

    const hoverText = props.hoverText ?? "";

    const onClick = props.onClick ?? function () {};

    const handleOnClick = () => {
        onClick();
    };

    return (
        <div id={uniqueIdentifier + "-div"} title={hoverText} style={{bottom: "2.5rem", right: "2.5rem", position: "fixed"}}>
            <Fab id={uniqueIdentifier}
                 name={uniqueIdentifier}
                 onClick={handleOnClick}
                 color="primary"
                 sx={{float: "right"}}>
                <AddIcon color="white"/>
            </Fab>
        </div>
    );
}


